export default __webpack_public_path__ + "static/media/logo.dca5dce0.png";